import axios from 'axios';

// Configura la URL base si es necesario
axios.defaults.baseURL = 'https://api3.argoth.com.mx';
//axios.defaults.baseURL = 'http://localhost:3010';

const AUTH_STORAGE_KEYS = ['token', 'userRole', 'userId', 'userName'];

function clearAuthSession() {
  AUTH_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
}

axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const isLoginRequest = requestUrl.includes('/api/auth/login');

    if (status === 401 && !isLoginRequest) {
      clearAuthSession();

      if (window.location.pathname !== '/login') {
        window.location.replace('/login');
      }
    }

    return Promise.reject(error);
  }
);

export default axios; 